import styled from 'styled-components';
// import { media, header } from '../../constants/theme';

export const StyledLayoutWrapper = styled.div``;
